export default __webpack_public_path__ + "static/analysts_Architect_INTJ_friendships-1c146fcdead84ff12e5d79836d296c64.svg";